import React from "react";
import Column from "@amzn/meridian/column";
import Row from "@amzn/meridian/row";
import { HeadSection, FooterTablet } from "../../../shared";
import ProductMobile from "../mobile/productMobile";
import "../eligibleProduct.css";
import { useBundle } from "@amzn/react-arb-tools";
import { PRODUCTPAGE_MESSAGE_BUNDLE_NAME } from "src/constants";
import { t } from "src/helpers";

const EligibleProductTablet = () => {
  const [bundle] = useBundle(PRODUCTPAGE_MESSAGE_BUNDLE_NAME);
  const widths = ["grid-1", "grid-10"];

  return (
    <Column overflowY="scroll" heights={["10em", "5em", "fill", "5em"]}>
      <HeadSection type={"d50"} alignmentHorizontal={"center"} widths={widths}>
        {t(bundle, "compare_eligible_products")}
      </HeadSection>
      <Row></Row>
      <Row widths={widths}>
        <Column></Column>
        <ProductMobile></ProductMobile>
      </Row>
      <FooterTablet widths={["grid-1"]}></FooterTablet>
    </Column>
  );
};

export default EligibleProductTablet;
